import OspButton from './OspButton.vue';

export default OspButton;



// WEBPACK FOOTER //
// ./src/components/OspButton/index.js